import { Crud } from 'core/types/Crud'

interface IRemoveHpContactRequest {
  crud: Crud
  entryId: number | string
}

export const removeHpContactRequest = async ({ crud, entryId }: IRemoveHpContactRequest) => {
  await crud.delete(
    { formId: '1217', code: 'jbp-hp-contact-change-request-1217' },
    {
      EntryId: entryId,
    },
    'EntryId'
  )
}
